import { Dispatch } from 'redux';
import { useIntl } from 'react-intl';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { IProvisioningRules } from '../types/AdminProvision.interface';
import { updateFilteredProvisioningRules } from '../../../../actions/admin/adminProvisionActionCreators';

export default () => {
    const intl = useIntl();
    const dispatch: Dispatch<any> = useAppDispatch();
    const { provisioningRuleList } = useAppSelector(state => state.adminProvision.privileges);
    const selectOne = intl.formatMessage({ id: 'admin.provision.dropdownSelectOne' });

    const hasSameRule = (selectedProvisioningRole: string, selectedManagedRole: string) => {
        return provisioningRuleList.some(
            (rule: IProvisioningRules) =>
                selectedProvisioningRole === rule.provisioning_role_label &&
                selectedManagedRole === rule.managed_role_label,
        );
    };

    const hasButtonDisabled = (
        selectedProvisioningRole: string = selectOne,
        selectedManagedRole: string = selectOne,
    ) => {
        if (
            selectedProvisioningRole === selectOne ||
            selectedManagedRole === selectOne ||
            hasSameRule(selectedProvisioningRole, selectedManagedRole)
        ) {
            return true;
        }
        return false;
    };

    const appyTableFilter = (provisioningRole: string = selectOne, managedRole: string = selectOne, isShowAllRules:boolean = false) => {
        if (provisioningRole === selectOne && managedRole === selectOne && !isShowAllRules) {
            return;
        }

        if (isShowAllRules) {
            dispatch(updateFilteredProvisioningRules(provisioningRuleList));
            return;
        }

        const filteredRules = provisioningRuleList.filter(
            (rule: IProvisioningRules) =>
                rule.provisioning_role_label === provisioningRole && rule.managed_role_label === managedRole,
        );
        dispatch(updateFilteredProvisioningRules(filteredRules));
    };

    return {
        hasSameRule,
        hasButtonDisabled,
        appyTableFilter,
    };
};
